export default "__VITE_ASSET__CXlFRkpQ__"